<div mat-dialog-title class="m-0">
    ดูรายงานผล
    <div style="float: right; margin-top: -5px;">

        <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()"
            style="float: right; margin-top: -6px;">
            <img src="../../../../assets/close-white.png" style="width: 12px;">
        </button>
        <button mat-icon-button [mat-dialog-close]="true" (click)="addEmail()" style="float: right; margin-top: -6px;">
            <img src="../../../../assets/add-contact.png" style="width: 22px;">
        </button>

    </div>
</div>


<mat-dialog-content id="modalSelectReport" class="mat-typography">
    <div class="container py-4 px-0">
        <div *ngIf="otherReport.length === 0" class="row d-flex justify-content-center">
            <h3 class="text-center text-secondary">
                ยังไม่มีผู้แชร์รายงานผล
            </h3>
        </div>
        <div *ngIf="otherReport.length > 0" class="row d-flex justify-content-center">
            <div *ngFor="let report of otherReport"
                class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-center">
                <div *ngIf="report.MEASURE_DONE" class="btn btn-report btn-other-report my-2" (click)="selectReport(report)">
                    {{ report.MEASURE_CLIENT_EMAIL }}
                </div>
                <div *ngIf="!report.MEASURE_DONE" class="btn btn-report btn-disable-report my-2 disable-display">
                    {{ report.MEASURE_CLIENT_EMAIL }} (ยังไม่มีรายงานผล)
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>